<mat-form-field class="vertical-datum-control">
  <mat-label>
    {{ placeholder ? placeholder : ('configurations-fields.VerticalDatum' | translate) }}
  </mat-label>
  <input
    [required]="isRequired"
    type="text"
    matInput
    [formControl]="verticalDatumControl"
    [matAutocomplete]="auto"
  />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectDatum($event)" [displayWith]="displayedDatum.bind(this)">
    <mat-option *ngFor="let datum of filteredDatum$ | async" [value]="datum" [matTooltip]="getDatumTooltip(datum)">
      <span>{{ datum.title | uppercase }} ({{ datum.value }})</span>
      <span class="suggested-datum" *ngIf="datum.isSuggest"> (Suggested) </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
